import { FC, HTMLAttributes, useState } from 'react';

import { useSetRecoilState } from 'recoil';

import { Button } from '@shared/components/Button';
import { MyTimeKeeper } from '@shared/components/TimeKeeper';
import { simpleOpenAtomFamily } from '@shared/state/atom';
import { CustomCallback } from '@shared/types';
import { fromKstParts, toKstParts } from '@shared/utils/kstDate';

interface IProps extends HTMLAttributes<HTMLDivElement> {
  time: Date | null;
  onTimeChange: CustomCallback<Date, void>;
  openId: string;
}

//*Date를 timeIn string으로 변환 (한국 시간 기준)
const getTimeInFromDate = (time: Date | null) => {
  if (time) {
    const kst = toKstParts(time);
    const minuteString = kst.minutes < 10 ? `0${kst.minutes}` : String(kst.minutes);

    return `${kst.hours}:${minuteString}`;
  } else {
    //undefined일때 12:30처럼 동작함
    return '12:30';
  }
};

//*TimeKeeper 를 통해 나온 timeout String을 통해 setTime함
//* 시·분은 한국 시간(KST) 값으로 해석해 순간값을 만든다(날짜 부분은 호출부에서 다시 합성).
const formatTimetoDate = (timeOut: string | undefined) => {
  if (timeOut) {
    const hourNum = Number(timeOut.split(':')[0]);
    const minutesNum = Number(timeOut.split(':')[1]);
    const today = toKstParts(new Date());
    return fromKstParts(today.year, today.month, today.date, hourNum, minutesNum);
  }
};

//* FeventTimePickerModal
/**
 * time은 초기값 만들어주기 위함
 * onTimeChange (setValue들어간) 필수
 *
 * @param param0
 * @returns
 */
const TimePickerModal: FC<IProps> = ({
  time,
  openId,
  placeholder,
  onTimeChange,
}: IProps) => {
  const setOpen = useSetRecoilState(simpleOpenAtomFamily(openId));

  const [timeString, setTimeString] = useState<string | undefined>(
    getTimeInFromDate(time),
  );

  const onConfirmClick = () => {
    // Set Value
    const date = formatTimetoDate(timeString);
    if (date) {
      onTimeChange(date);
    }
    // Close Modal
    setOpen(false);
    history.back();
  };

  return (
    <div className="rounded-t-2xl p-6 text-sm theme-text-1 theme-bg-1">
      {/* Top */}
      <h4 className="bugo-h1 text-center">{placeholder}</h4>
      {/* Main Content */}
      <div className="center-box py-4">
        <MyTimeKeeper time={timeString} setTime={setTimeString} />
      </div>
      {/* Confirm Button */}
      <div className="pb-4">
        <Button
          onClick={onConfirmClick}
          className="button-rectangle text-white theme-bg-main"
        >
          확인
        </Button>
      </div>
    </div>
  );
};

export default TimePickerModal;
